module.exports = __webpack_public_path__ + "img/village.cb4b8965.jpg";